export default __webpack_public_path__ + "static/media/seashoretreasure.f497f3f1.png";